import { createPageSegmentLoadMetric, SHARE_BUTTON_SEGMENT_KEY } from '@confluence/browser-metrics';

export const SHARE_BUTTON_PAGE_SEGMENT_LOAD = createPageSegmentLoadMetric({
	key: SHARE_BUTTON_SEGMENT_KEY,
});
